module.exports = __webpack_public_path__ + "static/img/banner2.d137944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/banner2.png
// module id = Qw12
// module chunks = 44